import { setupAxiosInterceptor } from 'network/config/axiosInterceptor';
import { queryClient } from 'network/config/queryKeys';
import { madinaHealthCheck } from 'network/services/madina';
import { useEffect } from 'react';
import { QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import { branchIdAtom, branchNameAtom } from 'store/atoms/branchAtom';
import { getStoredBranchId } from 'utils/branch';
import { AppNavigation } from './navigation/AppNavigation';
import ScrollToTop from './utils/scrollToTop';

export const App = () => {
  const setBranchId = useSetRecoilState(branchIdAtom);
  const setBranchName = useSetRecoilState(branchNameAtom);

  useEffect(() => {
    setupAxiosInterceptor();
    madinaHealthCheck().catch(() => undefined);

    const storedBranchId = getStoredBranchId();
    if (storedBranchId) {
      setBranchId(storedBranchId);
      const storedName = localStorage.getItem('madina_branch_name');
      if (storedName) setBranchName(storedName);
    }
  }, [setBranchId, setBranchName]);

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ScrollToTop />
        <AppNavigation />
      </BrowserRouter>
    </QueryClientProvider>
  );
};

export default App;
